import { CodingApi, CoreFetch, ProviderCoderRule, SupportCoderRule } from '../../api';
import { isDemoModeActive } from '../auth/demo-mode.utils';
import { CoderRuleSummary } from './automation/worker-automation.types';
import { WorkerConfigurationApiMode } from './worker-configuration.api';

/** Loaded on demand — a static import ships the demo catalogue to every customer. */
const demoCoderRules = () => import('../demo/coder-rules.demo');

function toCoderRuleSummary(rule: ProviderCoderRule | SupportCoderRule): CoderRuleSummary | null {
    if (typeof rule.ruleNumber !== 'number') {
        return null;
    }

    return {
        ruleNumber: rule.ruleNumber,
        description: rule.description ?? '',
        // Unset reads as active: an EXECUTE_ENTER_FUNCTION rule referencing it should still show it
        // enabled rather than silently hiding it as inactive.
        isActive: rule.isActive !== false,
    };
}

/** The account's coder rules, for the "disable these on this claim" picker on an Execute Function action. */
export async function fetchCoderRules(apiMode: WorkerConfigurationApiMode): Promise<CoderRuleSummary[]> {
    if (isDemoModeActive()) {
        const { demoCoderRuleSummaries } = await demoCoderRules();
        return demoCoderRuleSummaries();
    }

    const api = CoreFetch<CodingApi>(CodingApi);
    const rules = apiMode === 'provider' ? await api.getProviderCoderRules() : await api.getSupportCoderRules();

    return rules
        .map(toCoderRuleSummary)
        .filter((rule): rule is CoderRuleSummary => rule !== null)
        .sort((left, right) => left.ruleNumber - right.ruleNumber);
}
